import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, EditableItem, LL_V_L, TS_Button, TS_PropRenderer } from '@nu-art/thunderstorm-frontend';
import { Editor_JsonToObject } from '../Editor_JsonToObject.js';
import { tsValidateString } from '@nu-art/ts-common';
const validator = {
    a: tsValidateString(-1),
    b: tsValidateString(-1),
    c: tsValidateString(-1)
};
export class ATS_JsonToObject extends ComponentSync {
    static screen = { name: `DevTool - JsonToObject`, renderer: this };
    static defaultProps = {
        modules: [],
        pageTitle: () => this.screen.name
    };
    deriveStateFromProps(nextProps, state) {
        state.freeText ??= false;
        state.editable ??= new EditableItem({}).setAutoSave(true);
        return state;
    }
    constructor(p) {
        super(p);
    }
    render() {
        return _jsxs(LL_V_L, { children: [_jsx(Editor_JsonToObject, { isFreeTextMode: this.state.freeText, validator: validator, editable: this.state.editable, renderer: (editable) => {
                        const item = editable.item;
                        return _jsxs(LL_V_L, { children: [_jsx(TS_PropRenderer.Vertical, { label: 'property a', children: item.a ?? 'no A' }), _jsx(TS_PropRenderer.Vertical, { label: 'property b', children: item.b ?? 'no B' })] });
                    } }), _jsx(TS_Button, { onClick: () => this.reDeriveState({ freeText: !this.state.freeText }), children: "toggle" })] });
    }
}
//# sourceMappingURL=ATS_JsonToObject.js.map